// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Panama */
const PA = /^(?:(?:1[16]1|21[89]|6\d{3}|8(?:1[01]|7[23]))\d{4})$/;

export default PA;
